/**
 * SRN Homes Landing Page — Shopify JS
 * Handles: header scroll, mobile nav, path toggle, modal, form submission
 */

(function() {
  'use strict';

  // ===== Header Scroll =====
  const header = document.querySelector('.srn-header');
  if (header) {
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          header.classList.toggle('srn-header--scrolled', window.scrollY > 40);
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  // ===== Mobile Nav =====
  var menuToggle = document.querySelector('.srn-header__menu-toggle');
  var mobileNav = document.getElementById('SrnLandingMenu');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function() {
      var isOpen = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // ===== Path Toggle =====
  const toggleBtns = document.querySelectorAll('.srn-path-toggle__btn');
  const slider = document.getElementById('srnToggleSlider');
  const paths = {
    investor: document.getElementById('srn-path-investor'),
    dreamer: document.getElementById('srn-path-dreamer')
  };
  /* Hero text is static — not updated by toggle */

  function positionSlider(activeBtn) {
    if (!slider || !activeBtn) return;
    var wrapper = activeBtn.parentElement;
    var wrapperRect = wrapper.getBoundingClientRect();
    var btnRect = activeBtn.getBoundingClientRect();
    var offsetLeft = btnRect.left - wrapperRect.left;
    slider.style.width = btnRect.width + 'px';
    slider.style.transform = 'translateX(' + (offsetLeft - 4) + 'px)';
  }

  function switchPath(path) {
    toggleBtns.forEach(function(b) {
      var isActive = b.dataset.path === path;
      b.classList.toggle('active', isActive);
      b.setAttribute('aria-pressed', isActive);
      if (isActive) positionSlider(b);
    });

    Object.keys(paths).forEach(function(key) {
      if (paths[key]) {
        paths[key].classList.toggle('active', key === path);
      }
    });

    /* Hero text remains static — no longer updates on toggle */

    var interest = document.getElementById('srn-interest');
    if (interest) {
      interest.value = path === 'investor' ? 'investment' : 'dream-home';
    }
  }

  toggleBtns.forEach(function(b) {
    b.addEventListener('click', function() {
      switchPath(b.dataset.path);
    });
  });

  if (toggleBtns.length > 0) {
    requestAnimationFrame(function() {
      positionSlider(toggleBtns[0]);
    });
    window.addEventListener('resize', function() {
      var activeBtn = document.querySelector('.srn-path-toggle__btn.active');
      if (activeBtn) positionSlider(activeBtn);
    });
  }

  // ===== Modal =====
  var backdrop = document.getElementById('srnConsultModal');
  var formView = document.getElementById('srnFormView');
  var formSuccess = document.getElementById('srnFormSuccess');
  var form = document.getElementById('srnConsultForm');

  function openModal() {
    if (backdrop) {
      backdrop.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (formView) formView.style.display = 'block';
      if (formSuccess) formSuccess.classList.remove('active');
    }
  }

  function closeModal() {
    if (backdrop) {
      backdrop.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  document.querySelectorAll('[data-srn-open-modal]').forEach(function(btn) {
    btn.addEventListener('click', openModal);
  });

  document.querySelectorAll('[data-srn-close-modal]').forEach(function(btn) {
    btn.addEventListener('click', closeModal);
  });

  if (backdrop) {
    backdrop.addEventListener('click', function(e) {
      if (e.target === backdrop) closeModal();
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && backdrop && backdrop.classList.contains('active')) {
      closeModal();
    }
  });

  // ===== Form Submission =====
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var recipientEl = document.getElementById('srn-recipient-email');
      var recipientEmail = recipientEl ? recipientEl.value : '';
      var formData = new FormData(form);
      if (recipientEmail) {
        formData.append('recipient_email', recipientEmail);
      }
      /* Send via Shopify contact form endpoint */
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'contact' : '/contact', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      }).catch(function() {});
      if (formView) formView.style.display = 'none';
      if (formSuccess) formSuccess.classList.add('active');
    });
  }
})();
